/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { CheckoutItemRequest } from 'src/js/model/checkout/request/CheckoutItemRequest';
import { FULFILLED } from '../../common/actions/ActionUtils';
import { ContactState } from '../../services/IshState';
import { Course, CourseClass, Product } from '@api';
import { GABuilder } from 'src/js/services/CommonAnalyticsService';

export const Actions = {
  ADD_CLASS_TO_CART: 'ADD_CLASS_TO_CART',
  REMOVE_CLASS_FROM_CART: 'REMOVE_CLASS_FROM_CART',

  ADD_WAITING_COURSE_TO_CART: 'ADD_WAITING_COURSE_TO_CART',
  REMOVE_WAITING_COURSE_FROM_CART: 'REMOVE_WAITING_COURSE_FROM_CART',

  ADD_PRODUCT_TO_CART: 'ADD_PRODUCT_TO_CART',
  REMOVE_PRODUCT_FROM_CART: 'REMOVE_PRODUCT_FROM_CART',

  ADD_PROMOTION_TO_CART: 'ADD_PROMOTION_TO_CART',
  REMOVE_PROMOTION_FROM_CART: 'REMOVE_PROMOTION_FROM_CART',

  HIDE_POPUP: 'HIDE_POPUP',
  UPDATE_POPUP: 'UPDATE_POPUP',
  REQUEST_COURSE: 'REQUEST_COURSE',
  REQUEST_COURSE_CLASS: 'REQUEST_COURSE_CLASS',
  REQUEST_INACTIVE_COURSE: 'REQUEST_INACTIVE_COURSE',
  REQUEST_WAITING_COURSE: 'REQUEST_WAITING_COURSE',
  REQUEST_PRODUCT: 'REQUEST_PRODUCT',
  REQUEST_PROMOTION: 'REQUEST_PROMOTION',
  REQUEST_CONTACT: 'REQUEST_CONTACT',
  REQUEST_SUGGESTION: 'REQUEST_SUGGESTION',

  SYNC_CART: 'SYNC_CART',
  /**
   * Put a html loaded course class to this redux store
   */
  PutClassToStore: 'web/courses/class/add',
};

/**
 * Request course classes by id or code
 */
export function requestCourse({ id, code, addToCart }: CheckoutItemRequest) {
  return {
    type: Actions.REQUEST_COURSE,
    payload: { id, code, addToCart }
  };
}

/**
 * Request course class by id or code
 */
export function requestCourseClass({ id, code, addToCart }: CheckoutItemRequest) {
  return {
    type: Actions.REQUEST_COURSE_CLASS,
    payload: { id, code, addToCart }
  };
}

export const requestSuggestion = () => ({
  type: Actions.REQUEST_SUGGESTION
});

/**
 * Request product by id or code
 */
export function requestProduct({ id, code, addToCart }: CheckoutItemRequest) {
  return {
    type: Actions.REQUEST_PRODUCT,
    payload: { id, code, addToCart }
  };
}

/**
 * Request waiting course by id
 */
export function requestWaitingCourse(id: string, addToCart?: boolean) {
  return {
    type: Actions.REQUEST_WAITING_COURSE,
    payload: { id, addToCart }
  };
}

/**
 * add product to cart
 */
export function addProductToCart(product: Product) {
  return {
    type: Actions.ADD_PRODUCT_TO_CART,
    payload: product,
    meta: {
      analytics: GABuilder.addProductToCart(product),
    },
  };
}

/**
 * add course class to cart
 */
export function addWaitingCourseToCart(course: Course) {
  return {
    type: Actions.ADD_WAITING_COURSE_TO_CART,
    payload: course,
  };
}


/**
 * add course class to cart
 */
export function addClassToCart(courseClass: CourseClass) {
  return {
    type: Actions.ADD_CLASS_TO_CART,
    payload: courseClass,
    meta: {
      analytics: GABuilder.addCourseClassToCart('class', courseClass),
    },
  };
}

/**
 * Update popup by passed content
 * @param {VirtualDOM} Content content which you want to display in popup
 * @return {Object} Action UPDATE_POPUP
 */
export function updatePopup(content) {
  return {
    content,
    type: Actions.UPDATE_POPUP,
  };
}

/**
 * Hide popup
 * @return {Object} Action HIDE_POPUP
 */
export function hidePopup() {
  return {
    type: Actions.HIDE_POPUP,
  };
}

export const addContact = function (contact: ContactState) {
  return { type: FULFILLED(Actions.REQUEST_CONTACT), payload: contact };
};
